import React from 'react';
import { ILanguage } from './core/types/ILanguage';

type AppContextType = {
    languages: ILanguage[],
    currentLanguage: string,
    updateCurrentLanguage: (code: string) => void
}

const AppContext = React.createContext<Partial<AppContextType>>({});

const useAppContext = () => {
    const context = React.useContext(AppContext);

    if (!context) {
        throw new Error(
          `There is no context`,
        )
      }
  
      return context
};

export {
    AppContext,
    useAppContext
};